import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddSignatureRole, UpdateSignatureRole } from '@completion/actions';
import { ButtonStatus, ResourceStatus, ResourceType } from '@completion/enums';
import { SignatureRole } from '@completion/models';
import { getResourceState } from '@completion/selectors';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-signature-role-edit-dialog',
  templateUrl: './signature-role-edit-dialog.component.html',
  styleUrls: ['./signature-role-edit-dialog.component.scss'],
  standalone: false,
})
export class SignatureRoleEditDialogComponent implements OnInit {
  signatureRole: SignatureRole;
  buttonStatus = ButtonStatus.IDLE;
  errorMsg: string | null;
  form: UntypedFormGroup;

  constructor(
    private readonly store: Store,
    public dialogRef: MatDialogRef<SignatureRoleEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly data = null,
    private readonly formBuilder: UntypedFormBuilder,
  ) {
    // Clone the provided role, including any ordinal assigned by the caller
    this.signatureRole = { ...this.data.signatureRole } as SignatureRole;
    this.store.select(getResourceState, ResourceType.UpdateSignatureRole).subscribe((state) => {
      if (state.status === ResourceStatus.Failure) {
        this.errorMsg = state.lastError;
      }
    });
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      name: [this.signatureRole.name, Validators.required],
      description: [this.signatureRole.description, Validators.required],
      groupEmail: [this.signatureRole.groupEmail],
    });
  }

  onSave() {
    if (this.form.valid) {
      this.buttonStatus = ButtonStatus.IN_PROGRESS;
      this.errorMsg = null;

      // Merge form values back into signatureRole, preserving ordinal when present
      this.signatureRole = {
        ...this.signatureRole,
        ...this.form.value,
      } as SignatureRole;

      if (this.signatureRole.id === null || this.signatureRole.id === undefined) {
        this.store.dispatch(new AddSignatureRole(this.signatureRole));
      } else {
        this.store.dispatch(new UpdateSignatureRole(this.signatureRole));
      }

      if (!this.errorMsg || this.errorMsg.length === 0) {
        this.buttonStatus = ButtonStatus.COMPLETED;
        setTimeout(() => (this.buttonStatus = ButtonStatus.IDLE), 2000);
        this.dialogRef.close();
      }
    }
  }
}
